import { WORKER_PLAN_MODAL_ACTION_TYPE } from "../actions-type";

const initialState = {
  workerPlanModalData: {},
  workerPlanOpenModal: false,
  workerPlanModalLoading: false,
};

export const workerPlanModalReducer = (state = initialState, action) => {
  switch (action.type) {
    case WORKER_PLAN_MODAL_ACTION_TYPE.GET_WORKER_PLAN_MODAL:
      return {
        ...state,
        workerPlanModalData: action.payload.data,
        workerPlanOpenModal: action.payload.openModal,
      };
    case WORKER_PLAN_MODAL_ACTION_TYPE.WORKER_PLAN_OPEN_MODAL:
      return { ...state, workerPlanOpenModal: action.payload };
    case WORKER_PLAN_MODAL_ACTION_TYPE.WORKER_PLAN_MODAL_LOADING:
      return { ...state, workerPlanModalLoading: action.payload };
    default:
      return state;
  }
};